// MaskedPhoneInput.tsx
import React from "react";
import { TextFieldProps } from "@mui/material/TextField";
import { CustomTextField } from "../../views/AddSignatories/AddSignatories";
import { IMaskInput } from "react-imask";

type MaskedInputProps = TextFieldProps & {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
};

const PhoneMask = React.forwardRef<HTMLInputElement, MaskedInputProps>(
  function PhoneMaskComponent(props, ref) {
    const { onChange, name, ...rest } = props;

    return (
        //@ts-ignore
      <IMaskInput
        {...rest}
        mask="+00 (00) 00000-0000"
        definitions={{ "#": /[0-9]/ }}
        unmask={false}
        inputRef={ref}
        name={name}
        onAccept={(val: any) => {
          onChange({
            target: { name, value: val }
          } as React.ChangeEvent<HTMLInputElement>);
        }}
      />
    );
  }
);

export const MaskedPhoneInput = ({ value, onChange }: { value: string; onChange: (e: any) => void }) => {
  return (
    <CustomTextField
      label="Telefone"
      name="telefone"
      value={value}
      onChange={onChange}
      InputProps={{
        inputComponent: PhoneMask as any,
      }}
      variant="standard"
      fullWidth
    />
  );
};
